const overlay = {
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
};

export const centeredOverlay = {
  ...overlay,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 10,
};

const flexColumn = {
  display: "flex",
  flexDirection: "column",
};

const flexCenter = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

export const flexBetween = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
};

export const emptyState = {
  textAlign: "center",
  py: 4,
  backgroundColor: "grey.50",
  borderRadius: 1,
  ...flexCenter,
  flex: 1,
};

export const countBar = {
  position: "absolute",
  left: 0,
  top: 0,
  bottom: 0,
  backgroundColor: "primary.main",
  opacity: 0.08,
  pointerEvents: "none",
  zIndex: 0,
};

export const dialogContent = {
  ...flexColumn,
  gap: 2,
  pt: 1,
};

export const dialogActions = {
  ...flexBetween,
  gap: 1,
  px: 3,
  pb: 2,
};

export const truncatedText = {
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
};

export const relativeContainer = {
  position: "relative",
};

export const buttonText = {
  ...truncatedText,
  textTransform: "none",
  flexShrink: 0,
  minWidth: 0,
  maxWidth: "150px",
  "& .MuiButton-endIcon": {
    marginLeft: "4px",
  },
  justifyContent: "flex-start",
};
